import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { 
  ChatBubbleLeftRightIcon, 
  CpuChipIcon, 
  CommandLineIcon,
  RocketLaunchIcon,
  ArrowPathIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';

// Define the services data
export const servicesListData = [
  {
    icon: ChatBubbleLeftRightIcon,
    title: "AI Agents",
    description: "Sophisticated AI agents tailored to address diverse operational needs across all industries.",
    slug: "ai-appointment-setters"
  },
  {
    icon: CpuChipIcon,
    title: "Custom AI Solutions",
    description: "Tailored machine learning models and AI applications built for your specific business needs.",
    slug: "custom-ai-solutions"
  },
  {
    icon: CommandLineIcon,
    title: "RAG Bots",
    description: "Retrieval-Augmented Generation bots that provide accurate, context-aware responses.",
    slug: "rag-bots"
  },
  {
    icon: RocketLaunchIcon,
    title: "AI Web Applications",
    description: "Full-stack web applications powered by cutting-edge LLMs and AI technologies.",
    slug: "ai-web-applications"
  },
  {
    icon: ArrowPathIcon,
    title: "Process Automation",
    description: "Streamline your business operations with intelligent automation solutions.",
    slug: "process-automation"
  },
  {
    icon: ChartBarIcon,
    title: "Data Science Solutions",
    description: "Advanced analytics and data-driven insights to power your business decisions.",
    slug: "data-science-solutions"
  }
];

const ServicesList = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  return (
    <section id="services" className="section-padding bg-white">
      <div className="container">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">Our Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesListData.map((service, index) => (
            <Link 
              key={index} 
              to={`/services#${service.slug}`} 
              className="block"
            >
              <motion.div
                ref={ref}
                initial={{ opacity: 1, y: 20 }}
                animate={inView ? { opacity: 1, y: 1 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group p-6 rounded-xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:translate-y-[-5px] cursor-pointer border border-transparent hover:border-[#FF7066]/20"
              >
                <service.icon className="w-12 h-12 text-primary group-hover:text-[#FF7066] transition-colors duration-300 mb-4" />
                <h3 className="text-xl font-semibold mb-2 group-hover:text-[#FF7066] transition-colors duration-300">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
                <div className="mt-4 text-primary group-hover:text-[#FF7066] font-medium flex items-center gap-1 transition-colors duration-300">
                  <span>Learn more</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesList;